<template>
  <section class='signup default-content'>
    <div class='signup__container'>
      <div class='signup__column signup__info'>
        <h2 class='section-title'>{{ title }}</h2>
        <p class='signup__text'>{{ content }}</p>
      </div>
      <div class='signup__column'>
        <form class='signup__form' id='newsletterForm' data-vv-scope='newsletterForm'>
          <theme-input
            :show-label='false'
            name='email'
            placeholder='Enter your email'
            v-validate='`required|email`'
            :value='email'
            valid-scope='newsletterForm'
          />
          <div class='signup__button'>
            <button
              type='submit'
              id='newsletterSubmit'
              class='theme-btn theme-btn--theme theme-btn--block whitespace-nowrap'
              @click.prevent='signup'
            >
              {{ locales && locales.common && locales.common.signup }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
  import {mapGetters} from 'vuex';
  import field from '../admin/mixins/field';
  import $ from 'jquery';
  import sweetalert from 'sweetalert';

  export default {
    $_veeValidate: {
      validator: 'new',
    },
    props: {
      title: {
        default: '',
        type: String,
      },
      content: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        email: '',
      };
    },
    mixins: [field],
    computed: {
      ...mapGetters(['locales']),
    },
    methods: {
      signup() {
        this.$validator.validateAll('newsletterForm').then((valid) => {
          if (valid) {
            var data = $('#newsletterForm').serialize();
            $.ajax({
              url: `/api/newsletter/unregistered-signup`,
              data: data,
              method: 'post',
              success: (response) => {
                this.email = '';
                this.$validator.reset();
                sweetalert(this.locales.common.success, this.locales.newsletter.signed_up_message, 'success');
              },
              error: (err) => {
                sweetalert(this.locales.common.error, err.responseJSON.error, 'error');
              },
            });
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/Signup.vue